import { mapActions } from 'vuex';
import { STATIC_PAGES } from '@/constants';
import cmsContentMixin from '@/mixins/cmsContent';
import loaderMixin from '@/mixins/loader';
import contentLoaderMixin from '@/mixins/contentLoader';
import staticPageHeader from '@/components/static-page-header/static-page-header.vue';

export default {
  mixins: [
    cmsContentMixin,
    loaderMixin,
    contentLoaderMixin,
  ],
  components: {
    staticPageHeader,
  },
  metaInfo() {
    return {
      title: 'Responsible Trading',
    };
  },
  data() {
    return {
      content: '',
    };
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
  },
  created() {
    this.loaderAdd(document.body);
    this.getStaticPageFull(STATIC_PAGES.RESPONSIBLE_TRADING)
      .then((data) => {
        this.isComponentReady = true;
        this.installDynamicControls({ data });
      })
      .then(() => this.loaderRemove(document.body))
      .catch(() => this.loaderRemove(document.body));
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-responsible-trading/page-responsible-trading.js